import request from '@/utils/request'

// 用户相关接口
export const userApi = {
  login(data) {
    return request({
      url: '/user/login',
      method: 'post',
      data
    })
  },
  getUserInfo() {
    return request({
      url: '/user/info',
      method: 'get'
    })
  }
}

// 其他模块接口
export const otherApi = {
  getList(params) {
    return request({
      url: '/list',
      method: 'get',
      params
    })
  },
  createItem(data) {
    return request({
      url: '/item',
      method: 'post',
      data
    })
  }
}

// 官网相关接口
export const websiteApi = {
  getPictureList() {
    return request({
      url: '/tcOfficialWeb/api/getCarouselList',
      method: 'get'
    })
  },
  getMenuTree(id) {
    return request({
      url: '/tcOfficialWeb/api/treeList',
      method: 'get',
      params: {
        id
      }
    })
  },
  getTcTrainArticle(params) {
    return request({
      url: '/tcOfficialWeb/api/getTcTrainArticle',
      method: 'get',
      params
    })
  },
  getLtCodificationDalist(params) {
    return request({
      url: '/pc/online/lt/getLtCodificationDalist',
      method: 'get',
      params
    })
  }
}